import { Button, Img } from './styles';
import sair from '../../assets/images/sair.svg';

export default function LogoutBTN({text, handleLogout}) {

  return (
    <Button  onClick={handleLogout}><Img src={sair} alt="sair-logo"/><small>{text}</small></Button>
  )
}